import { EEnvironment } from '@/shared/enum/enviroment.enum'

const isStageEnvironment = () => {
  const env = import.meta.env.VITE_APP_NODE_ENV as string
  const { href } = window.location

  return (
    env === EEnvironment.DEV ||
    env === EEnvironment.STAGE ||
    href.includes('test.claropayment') ||
    href.includes('mispagosclaro.com/stage') ||
    href.includes('portal-universal')
  )
}

export default isStageEnvironment
